module.exports = __webpack_public_path__ + "img/banner_charge.ff0fd2ac.png";